import { Country, State, City } from 'country-state-city';

// Get all Indian states
export const getIndianStates = () => {
  return State.getStatesOfCountry('IN').map(state => ({
    id: state.isoCode,
    name: state.name,
  }));
};

// Get all cities for a specific state
export const getCitiesOfState = (stateCode: string) => {
  return City.getCitiesOfState('IN', stateCode).map(city => ({
    id: city.name,
    name: city.name,
  }));
};

// Get state code by state name
export const getStateCodeByName = (stateName: string) => {
  const states = State.getStatesOfCountry('IN');
  const state = states.find(s => s.name === stateName);
  return state?.isoCode || '';
};

// Export the state names for dropdown
export const INDIAN_STATES = getIndianStates().map(state => state.name).sort();

// Get cities by state name (convenience function)
export const getCitiesByStateName = (stateName: string): string[] => {
  const stateCode = getStateCodeByName(stateName);
  if (!stateCode) return [];
  return getCitiesOfState(stateCode).map(city => city.name).sort();
};
